// Dependencies
import React, { Component } from 'react';
import { isMobileOnly } from 'react-device-detect';
import PageTitleComponent from '../../components/page-title/page-title';

// Primereact imports
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './training-registrations.scss';

// Redux
import { connect } from 'react-redux';
import TrainingService from '../../redux/services/training';

// Utils
import { ORDER_STATE_CANCELLED, ORDER_STATE_PAYED, ORDER_STATE_WAITING_PAYMENT, TRAINING_AREA_CONGRESS, TRAINING_REGISTRATION_STATE_CANCELLED, TRAINING_REGISTRATION_STATE_CLOSED, TRAINING_REGISTRATION_STATE_WAITING_PAYMENT } from '../../common/constants';
import { convertBase64ToArrayBuffer, downloadFile } from '../../common/utils/download-utils';
import { authenticationChecker } from '../../components/security/authentication-checker';

class TrainingRegistrationsPage extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            registrations: []
        };
    }

    componentDidMount() {
        TrainingService.getTrainingRegistrations(this.props.associate.associateId)
        .then((response) => {
            let registrations = [];

            for (let i = 0; i < response.registrations.length; i++) {
                if(response.registrations[i].trainingAreaId !== TRAINING_AREA_CONGRESS) {
                    registrations.push(response.registrations[i]);
                }
            }

            this.setState({
                registrations: registrations
            });
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("training-registrations.messages.error"), life: 3000 });
        });
    }

    dateBodyTemplate(rowData, column) {
        if(rowData[column] !== null) {
          return rowData[column] !== undefined ? rowData[column].replace('T',' ') : "";
        }
        else {
          return "";
        }
    }

    stateBodyTemplate(rowData) {
        if(rowData.trainingRegistrationState === TRAINING_REGISTRATION_STATE_CLOSED) {
            return <span className={'state-badge'} style={{background: '#C8E6C9', color: '#256029'}}>{this.props.t("training-registrations.form.closed")}</span>;
        }
        else if(rowData.trainingRegistrationState === TRAINING_REGISTRATION_STATE_WAITING_PAYMENT) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("training-registrations.form.waiting-payment")}</span>;
        }
        else if(rowData.trainingRegistrationState === TRAINING_REGISTRATION_STATE_CANCELLED) {
            return <span className={'state-badge'} style={{background: '#b80406', color: '#000000'}}>{this.props.t("training-registrations.form.cancelled")}</span>;
        }
    }

    certificateDownloadBodyTemplate(rowData) {
        console.log(rowData);
        return rowData.trainingCertificateDocRef !== null ? <Button icon="pi pi-download" onClick={() => this.downloadCertificateDocument(rowData.ballotRef, rowData.trainingId, rowData.trainingCertificateDocRef)} /> : null;
    }

    downloadCertificateDocument(ballotRef, trainingId, certificateDocRef) {
        TrainingService.downloadCertificateDocument({
            trainingId: trainingId,
            ballotRef: ballotRef,
            certificateDocRef: certificateDocRef
        })
          .then((response) => {
                if(response.fileContent !== null) {
                    var blob = new Blob([convertBase64ToArrayBuffer(response.fileContent)], { type: response.contentType });
                    downloadFile(URL.createObjectURL(blob), response.filename);
                }
          })
          .catch(error => {
              this._toast.current.show({ severity: 'error', detail: this.props.t("training-registrations.messages.error"), life: 3000 });
          });
    }

    render() {

       return (
            <div>
                <PageTitleComponent title={this.props.t("training-registrations.title")} />
                <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                    <div className='col-1'></div>
                    <div className="col-10">                   
                        <div id="data-container" className="card mgt-20">
                        {
                            this.state.registrations !== null ? 
                                <div className="grid">
                                    <div className="col-12">
                                        <DataTable value={this.state.registrations} className="p-datatable-gridlines" showGridlines rows={12} dataKey="trainingRegistrationRef" responsiveLayout="scroll" emptyMessage={this.props.t("training-registrations.messages.no-registrations")}>
                                            <Column field="title" header={this.props.t("training-registrations.form.title-header")} />
                                            <Column field="trainingStartDate" header={this.props.t("training-registrations.form.training-start-date-header")} body={(data) => this.dateBodyTemplate(data, 'trainingStartDate')} style={{ minWidth: '12rem' }} />
                                            <Column field="submitDate" header={this.props.t("training-registrations.form.submit-date-header")} body={(data) => this.dateBodyTemplate(data, 'submitDate')} style={{ minWidth: '12rem' }} />
                                            <Column field="trainingRegistrationState" header={this.props.t("training-registrations.form.state-header")} body={(data) => this.stateBodyTemplate(data)} style={{ minWidth: '10rem' }}  />
                                            <Column field="trainingCertificateDocRef" header={this.props.t("training-registrations.form.certificate-doc-header")} body={(data) => this.certificateDownloadBodyTemplate(data)} style={{ minWidth: '8rem' }}  />
                                        </DataTable>
                                    </div>
                                </div>
                                : null
                        }
                        </div>
                    </div>
                    <div className='col-1'></div>
                </div>
                <Toast position='bottom-left' ref={this._toast} />
            </div>
        );
  }

}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate
    } 
};
  
export default connect(mapStateToProps, undefined)(authenticationChecker(withTranslation(TrainingRegistrationsPage)));